// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"595":"84e90006","926":"b8c96dcb"}[chunkId] + ".chunk.js");